<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-links">
        <router-link to="/privacy">Privacy Policy</router-link>
        <router-link to="/terms">Terms of Service</router-link>
      </div>
      <div class="copyright">
        &copy; {{ new Date().getFullYear() }} MindYourBite. All rights reserved.
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter'
}
</script>

<style scoped>
.site-footer {
  padding: 40px 0;
  background-color: #f8f8f8;
  border-top: 1px solid #eaeaea;
  text-align: center;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.footer-links {
  margin-bottom: 20px;
}
.footer-links a {
  margin: 0 15px;
  text-decoration: none;
  color: #555;
  font-weight: 500;
}
.footer-links a:hover {
  text-decoration: underline;
}
.copyright {
  color: #888;
  font-size: 14px;
}
</style>
